import { ColumnFieldEditor } from "./components/Steps/DashboardFields/Editors/ColumnFieldEditor";
import { CustomFieldFieldEditor } from "./components/Steps/DashboardFields/Editors/CustomFieldFieldEditor";
import { FieldEditorProps } from "./components/Steps/DashboardFields/Editors/FieldEditorProps";
import { GoalFieldEditor } from "./components/Steps/DashboardFields/Editors/GoalFieldEditor";
import { SearchFieldEditor } from "./components/Steps/DashboardFields/Editors/SearchFieldEditor";
import { SurveyFieldEditor } from "./components/Steps/DashboardFields/Editors/SurveyFieldEditor";
import { AnswerableQuestionEditor } from "./components/Steps/DashboardFields/Editors/AnswerableQuestionEditor";

type FieldMapItem = {
  label: string;
  source: string;
  editorComponent: (props: FieldEditorProps) => JSX.Element;
  requiredField: string;
};

const FieldMap: FieldMapItem[] = [
  {
    label: "Field",
    source: "column",
    editorComponent: ColumnFieldEditor,
    requiredField: 'column',
  },
  {
    label: "Custom Field",
    source: "custom_field",
    editorComponent: CustomFieldFieldEditor,
    requiredField: 'customFieldId',
  },
  {
    label: "Goal",
    source: "goal",
    editorComponent: GoalFieldEditor,
    requiredField: 'goalId',
  },
  {
    label: 'Audience',
    source: 'search',
    editorComponent: SearchFieldEditor,
    requiredField: 'searchId',
  },
  {
    label: 'Survey Response',
    source: 'survey_response',
    editorComponent: SurveyFieldEditor,
    requiredField: 'questionId',
  },
  {
    label: 'Answer Question',
    source: 'answerable_question',
    editorComponent: AnswerableQuestionEditor,
    requiredField: 'questionId',
  }
];

export default FieldMap;
